<template>
  <router-view ></router-view>
</template>

<script>
export default {
  name: 'BlankRouter',
  data () {
    return {
    }
  },
  mounted(){
  }
}
</script>

<style lang='less'>

</style>
